export const keysTypes = {
    submissionPopupShown: "submissionPopupShown",
    presentationPopupShown: "presentationPopupShown",
}
